import { handleVersionMismatch } from 'actions/versionSync';
import * as CardActionTypes from 'actiontypes/cards';
import { VersionMismatch } from 'services/BaseService';
import CardService from 'services/CardsService';
import { ICardsService } from 'types/cards';

export const discardRequest = () => ({ type: CardActionTypes.DISCARD_CARDS_REQUESTED });

export const discardSuccess = (data: any) => ({
  type: CardActionTypes.DISCARD_CARDS_SUCCESS,
  payload: data,
});

export const discardFailure = (error: any) => ({
  type: CardActionTypes.FETCH_CARDS_FAILURE,
  error: true,
  status: error.response && error.response.status,
});

/** ----------------------------------------------------------------------------
 * DISCARD
 -----------------------------------------------------------------------------*/

export default discard(new CardService());

export function discard(service: ICardsService) {
  return (eventId: number) => async (dispatch: Function) => {
    dispatch(discardRequest());

    try {
      const { data } = await service.discardOpportunityCard(eventId);
      return dispatch(discardSuccess(data));
    } catch (error) {
      if (error instanceof VersionMismatch) {
        dispatch(handleVersionMismatch(error));
      }
      return dispatch(discardFailure(error));
    }
  };
}
